import { render, staticRenderFns } from "./TableFieldTextInput.vue?vue&type=template&id=133f930e"
import script from "./TableFieldTextInput.vue?vue&type=script&lang=js"
export * from "./TableFieldTextInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports